import { segmentTrack } from "@utils/segment/segment-track";
import { usePathname } from "next/navigation";

const linksList = ["button--social-card"];

const useOnClick = () => {
  const pathname = usePathname();

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    //e.preventDefault();

    const isLink = linksList.includes(e.currentTarget.className);

    const event = isLink ? "Link" : "Marketing CTA";

    // pathname is empty case when we navigate to different host url
    const locationPath =
      typeof window !== "undefined" ? window.location.pathname : "";

    segmentTrack(`${event} Clicked`, {
      action: "Clicked",
      initiator: "User",
      object: event,
      source_application: "Marketing",
      target: e.currentTarget.pathname,
      text: e.currentTarget.text,
      url: pathname || locationPath,
    });

    //router.push(e.currentTarget.href);
  };

  return { onClick };
};

export default useOnClick;
